import { i18n } from 'services';

export const isRequired = (value: unknown) => (value ? undefined : i18n.t('formValidationErrors.isRequired'));
